import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { ServiceChangeRequestReview } from './service-change-request-review.model';

export const loadServiceChangeRequestReviews = createAction(
  '[ServiceChangeRequestReview/API] Load ServiceChangeRequestReviews', 
  props<{ serviceChangeRequestReviews: ServiceChangeRequestReview[] }>()
);

export const addServiceChangeRequestReview = createAction(
  '[ServiceChangeRequestReview/API] Add ServiceChangeRequestReview',
  props<{ serviceChangeRequestReview: ServiceChangeRequestReview }>()
);

export const upsertServiceChangeRequestReview = createAction(
  '[ServiceChangeRequestReview/API] Upsert ServiceChangeRequestReview',
  props<{ serviceChangeRequestReview: ServiceChangeRequestReview }>()
);

export const addServiceChangeRequestReviews = createAction(
  '[ServiceChangeRequestReview/API] Add ServiceChangeRequestReviews',
  props<{ serviceChangeRequestReviews: ServiceChangeRequestReview[] }>()
);

export const upsertServiceChangeRequestReviews = createAction(
  '[ServiceChangeRequestReview/API] Upsert ServiceChangeRequestReviews',
  props<{ serviceChangeRequestReviews: ServiceChangeRequestReview[] }>()
);

export const updateServiceChangeRequestReview = createAction(
  '[ServiceChangeRequestReview/API] Update ServiceChangeRequestReview',
  props<{ serviceChangeRequestReview: Update<ServiceChangeRequestReview> }>()
);

export const updateServiceChangeRequestReviews = createAction(
  '[ServiceChangeRequestReview/API] Update ServiceChangeRequestReviews',
  props<{ serviceChangeRequestReviews: Update<ServiceChangeRequestReview>[] }>()
);

export const deleteServiceChangeRequestReview = createAction(
  '[ServiceChangeRequestReview/API] Delete ServiceChangeRequestReview',
  props<{ id: string }>()
);

export const deleteServiceChangeRequestReviews = createAction(
  '[ServiceChangeRequestReview/API] Delete ServiceChangeRequestReviews',
  props<{ ids: string[] }>()
);

export const clearServiceChangeRequestReviews = createAction(
  '[ServiceChangeRequestReview/API] Clear ServiceChangeRequestReviews'
);
